// 051 — TODO el formulario en FHIR (además del `Par[]` del PDF): orquesta los mapeos por sección en el mismo `LoteTransaccional`.
// Ver `base.ts` para el modelo (panel + `hasMember`, Condition, Procedure), las reglas de guardado y la fecha efectiva.
// El partograma NO va aquí (`../partograma/fhir.ts`), ni la extensión `datos-gestacionales` del Patient (`../fhir051.ts`).
import type { Encounter, Patient, Reference } from '@medplum/fhirtypes';
import type { EstadoIdentificacion051 } from '../bloques051IdentificacionDatos';
import type { EstadoParto051 } from '../bloques051PartoDatos';
import type { EstadoPagina2_051 } from '../bloques051PartogramaDatos';
import { agregarObservacionAlturaUterina } from '../fhir051';
import type { Traducir } from '../tecnicaAnestesicaDatos';
import type { LoteTransaccional } from '../transaccionFhir';
import { agregarAntecedentes } from './antecedentes';
import { ProcedimientosCreados, type Contexto051 } from './base';
import { agregarControlesPrenatales, agregarPostparto } from './controles';
import { agregarGestacionActual } from './gestacion';
import { agregarIntervenciones, agregarMorbilidad, agregarNearMiss } from './morbilidad';
import { agregarPartoAborto } from './parto';
import { agregarAnticoncepcion, agregarEgresos, agregarRecienNacido } from './reciennacido';

export interface Estado051Discretos {
  readonly identificacion: EstadoIdentificacion051;
  readonly parto: EstadoParto051;
  /** Solo se leen near miss, recién nacido y egresos (el partograma visual/tabla los guarda `partograma/fhir.ts`). */
  readonly pagina2: EstadoPagina2_051;
}

/**
 * Agrega al lote todos los recursos discretos del 051 (salvo partograma y extensión del Patient). Sin datos no agrega nada.
 * `ahora` fija el reloj (fecha efectiva cuando el papel no trae una) para poder testear.
 */
export function agregarDiscretos051(lote: LoteTransaccional, subject: Reference<Patient>, encounter: Reference<Encounter> | undefined, estado: Estado051Discretos, t: Traducir, ahora: Date = new Date()): void {
  const ctx: Contexto051 = { lote, subject, encounter, efectivo: ahora.toISOString(), t };
  const { identificacion, parto, pagina2 } = estado;
  const procedimientos = new ProcedimientosCreados(parto.partoAborto.nacimientoFecha);

  agregarAntecedentes(ctx, identificacion);
  agregarGestacionActual(ctx, identificacion.gestacionActual);
  const alturas: string[] = [];
  agregarObservacionAlturaUterina(lote, subject, encounter, identificacion.controlPrenatal, ahora, alturas);
  agregarControlesPrenatales(ctx, identificacion.controlPrenatal, alturas);
  agregarPartoAborto(ctx, parto.partoAborto, procedimientos);
  agregarPostparto(ctx, parto.postparto);
  agregarMorbilidad(ctx, parto.morbilidad);
  agregarIntervenciones(ctx, parto.intervenciones, procedimientos);
  agregarNearMiss(ctx, pagina2.nearMiss, procedimientos);
  agregarRecienNacido(ctx, pagina2.recienNacido);
  agregarEgresos(ctx, pagina2.egresoRn, pagina2.egresoMaterno);
  agregarAnticoncepcion(ctx, pagina2.egresoMaterno);
}
